export enum RegistrationChannel {
  Fbs = "FBS",
  Gas = "GAS",
}
